/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component } from "@angular/core";
import { AbstractModalComponent } from "../../common/commondialog/abstract-modal.component";
import { DebugConfigurationModel, DebugModuleEntry } from "../../common/model/debug-configuration-model";

@Component({
   standalone: false,
   selector: "debug-configuration-dialog",
   templateUrl: "./debug-configuration-dialog.html",
   styles: [
      `
         /deep/ .modal.show .modal-dialog {
            width: 451.89px;
         }
      `
   ]
})
export class DebugConfigurationDialogComponent extends AbstractModalComponent {
   public debugModuleList: Array<DebugModuleEntry> = [];

   constructor(private debugConfigurationModel: DebugConfigurationModel) {
      super();
      this.debugModuleList = this.debugConfigurationModel.getDebugConfigModuleList();
   }

   public debugConfigOkClicked = () => {
      this.debugConfigurationModel.setDebugConfigModuleList();
      this.closeModal();
   };

   public onKeypress = (evt) => {
      if (!!evt && evt.keyCode === 32) {
         // Space key is pressed.
         if (evt.target.children && evt.target.children[0]) {
            $(evt.target.children[0]).trigger("click");
         }
         // Prevent default behavior.
         evt.preventDefault();
      }
   };
}
